import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component } from '@angular/core';
import { BaseComponent } from '@portal-shared/app/components/base-components/base.component';

@Component({
  standalone: true,
  selector: 'al-blank-cell-renderer',
  template: ''
})
export class BlankCellRendererComponent extends BaseComponent implements ICellRendererAngularComp {
  public agInit() {}

  public refresh(): boolean {
    return true;
  }
}
